import React from 'react';

export const ROUTES = {
    home: '/',
    personalData: '/dati-personali',
    supply: '/indirizzo-fornitura',
    paymentRecap: '/recapito-pagamento',
    consents: '/consensi',
    recap: '/riepilogo',
    endPage: '/richiesta-ricevuta'
}

export const VALIDATORS_TYPE = {
    noValidation: 'NO_VALIDATION',
    noNumbers: 'NO_NUMBERS',
    onlyNumbers: 'ONLY_NUMBERS',
    email: 'EMAIL',
    fiscalCode: 'FISCAL_CODE',
    iban: 'IBAN',
    pod: 'POD',
    pdr: 'PDR',
    phone: 'PHONE',
    isPhoneValid: 'IS_PHONE_VALID',
    isProvinceValid: 'IS_PROVINCE_VALID',
    suffixLength: 'SUFFIX_MAX_LENGTH',
}

export const ERROR_TEXTS = {
    fieldRequired: "Campo obbligatorio",
    fieldsRequired: "È necessario compilare tutti i campi per continuare.",
    contractAccept: "È necessario accettare le condizioni del contratto per confermare l'attivazione.",
    consentAccept: "Campo Obbligatorio",
    genericAccept: "È necessario accettare per continuare",
    serverError: "Errore nel salvare i dati.",
    saveSuccess: "Dati salvati con successo.",
    globalValidationError: "Errore nella validazione dei campi",
    validationError: "Formato errato",
    privacyNotAccepted: "È necessario accettare il trattamento dei dati per continuare.",
    areaNotCoveredByOffer: <span>Nella tua zona sono disponibili solo offerte per la luce. Per procedere con la sottoscrizione della fornitura di energia elettrica, clicca sul <a href="../?offerId=5866&tipologia_offerta=variabile&referrer=corporate">seguente link</a></span>,
    invalidFiscalCode: "Codice fiscale invalido",
    ageFiscalCode: "Bisogna essere maggiorenni per continuare",
    invalidIban: "Iban non valido",
    podInvalid: "POD invalido",
    pdrInvalid: "PDR invalido",
    emailsNotEqual: "La conferma dell'email non è uguale all'email.",
    phoneInvalidFormat: "Il cellulare non è valido.",
    provinceWrongFormat: "Formato provincia errato",
    podAlreadyClient: "Ci risulta già presente il codice POD inserito. Per informazioni, ti invitiamo a contattarci via chat o chiamando il Numero Verde 800 15 13 13",
    pdrAlreadyClient: "Ci risulta già presente il codice PDR inserito. Per informazioni, ti invitiamo a contattarci via chat o chiamando il Numero Verde 800 15 13 13",
    podTimeGateServerError: "Errore nel verificare il POD timegate",
    pdrTimeGateServerError: "Errore nel verificare il PDR timegate",
    pdrTimeGateError: "Ci risulta già presente una richiesta con il PDR inserito. Per informazioni sulla fornitura richiesta, ti invitiamo a contattarci via chat o telefonando al numero verde 800 15 13 13, attivo da lunedì a sabato, dalle 8 alle 22, festività escluse",
    podTimeGateError: "Ci risulta già presente una richiesta con il POD inserito. Per informazioni sulla fornitura richiesta, ti invitiamo a contattarci via chat o telefonando al numero verde 800 15 13 13, attivo da lunedì a sabato, dalle 8 alle 22, festività escluse",
}

export const INPUT_TYPES = {
    text: "text",
    select: "select",
    selectEditable: "selectEditable"
}

export const PAYMENT_METHODS = {
    bankAccount: 'contoCorrente',
    postal: "bollettinoPostale"
}
export const SHIPMENT_METHODS = {
    digitalBill: "bollettaDigitale",
    paperBill: "bollettaCartacea"
}
export const CALL_ME_START_HOUR = 9;
export const CALL_ME_END_HOUR = 20;

const COMMON_LINKS = [
    {
        label: 'Kit Contrattuale',
        url: 'https://vivigas.imgix.net/uploads/2019/11/12132127/KITLibero.pdf',
    },
    {
        label: 'Guida alla lettura',
        url: 'https://vivigas.imgix.net/uploads/2019/11/12135641/GLOSSARIO-VIVIWEB-NEW-LUCE-e-GAS-DOMESTICO-2019.pdf'
    }
]

export const ACCORDION_LINKS = {
    gas: [{
        label: 'VIVIweb Gas',
        url: 'https://vivigas.imgix.net/uploads/2020/01/23172441/contratto-viviweb-gas.pdf'
    }, ...COMMON_LINKS],
    energyMono: [{
        label: 'VIVIweb Luce monorario',
        url: 'https://vivigas.imgix.net/uploads/2020/01/23172439/contratto-VIVIweb-Luce-Monorario.pdf',
    }, ...COMMON_LINKS],
    energyBio: [{
        label: 'VIVIweb Luce biorario',
        url: 'https://vivigas.imgix.net/uploads/2020/01/23172438/contratto-VIVIweb-Luce-Biorario.pdf',
    }, ...COMMON_LINKS],
    energyGasMono: [{
        label: 'VIVIweb LuceGas monorario',
        url: 'https://vivigas.imgix.net/uploads/2020/01/23172441/contratto-VIVIweb-Lucegas-Monorario.pdf',
    }, ...COMMON_LINKS],
    energyGasBio: [{
        label: 'VIVIweb LuceGas biorario',
        url: 'https://vivigas.imgix.net/uploads/2020/01/23172440/contratto-VIVIweb-Lucegas-Biorario.pdf',
    }, ...COMMON_LINKS]
}
